import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faTimesCircle,
  faQuestionCircle,
} from '@fortawesome/pro-regular-svg-icons';

import styles from '../PlayerPortalsOnSiteRegistrationAdminPanel.module.scss';

type DashboardProps = {
  registeredLabel: string;
  notRegisteredLabel: string;
  dataFilledInAndNotRegisteredLabel: string;
  participants: any[];
};

export const Dashboard = (props: DashboardProps) => {
  const {
    registeredLabel,
    notRegisteredLabel,
    dataFilledInAndNotRegisteredLabel,
    participants,
  } = props;

  const getParticipantsInfo = () => {
    let registeredNr = 0;
    let notRegisteredNr = 0;
    let dataFilledInAndNotRegisteredNr = 0;

    participants.forEach((p: any) => {
      const status = Number(p.registrationStatus?.value);

      switch (status) {
        case 0:
          notRegisteredNr++;
          break;
        case 1:
          dataFilledInAndNotRegisteredNr++;
          break;
        case 2:
          registeredNr++;
          break;
      }
    });

    return {
      registeredNr,
      notRegisteredNr,
      dataFilledInAndNotRegisteredNr,
    };
  };

  const participantsInfo = getParticipantsInfo();

  const infoItems = [
    {
      icon: faCheckCircle,
      label: registeredLabel,
      value: participantsInfo?.registeredNr,
      iconClass: styles.registeredIcon,
    },
    {
      icon: faTimesCircle,
      label: notRegisteredLabel,
      value: participantsInfo?.notRegisteredNr,
      iconClass: styles.notRegisteredIcon,
    },
    {
      icon: faQuestionCircle,
      label: dataFilledInAndNotRegisteredLabel,
      value: participantsInfo?.dataFilledInAndNotRegisteredNr,
      iconClass: styles.dataFilledInAndNotRegisteredIcon,
    },
  ];

  return (
    <div className={` ${styles.card} ${styles.dashboard}`}>
      {infoItems.map(({ icon, label, value, iconClass }) => (
        <div className={styles.dashboardItem} key={label}>
          <div className={`${styles.iconContainer} ${iconClass}`}>
            <FontAwesomeIcon icon={icon} className={styles.icon} />
          </div>
          <div className={styles.infoText}>
            <span className={styles.label}>{label}</span>
            <span className={styles.value}>{value}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Dashboard;
